import { render, staticRenderFns } from "./PolicyRiskTrailer.vue?vue&type=template&id=678dae58&"
import script from "./PolicyRiskTrailer.vue?vue&type=script&lang=js&"
export * from "./PolicyRiskTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports